/* eslint-disable @next/next/no-img-element */
import { Card } from '@/components/Card';
import styles from '@/components/MovieTheaterCard/MovieTheaterSkeltonCard.module.scss';

// =================================================================

const CARD_ASPECT_RATIO = 281 / 402;

// =================================================================

export const MovieTheaterSkeltonCard = () => {
  return (
    <Card className={styles.movieCard}>
      <div style={{ paddingBottom: `${100 / CARD_ASPECT_RATIO}%` }} className={styles.skeltonImage}>
        <img src="/assets/images/movie-card-placeholder.png" alt="movie-card-skelton" />
      </div>
    </Card>
  );
};
